
import React from "react";
import { Search, X, Filter, FolderIcon } from "lucide-react";
import { Input } from "@/components/ui/input";
import { Button } from "@/components/ui/button";
import { Switch } from "@/components/ui/switch";
import { Label } from "@/components/ui/label";
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/components/ui/select";

interface Folder {
  id: string;
  name: string;
}

interface FloorPlanFiltersProps {
  searchQuery: string;
  setSearchQuery: (query: string) => void;
  selectedFolder: string;
  setSelectedFolder: (folderId: string) => void;
  folders: Folder[];
  showFavorites?: boolean;
  onToggleFavorites?: (show: boolean) => void;
}

export function FloorPlanFilters({
  searchQuery,
  setSearchQuery,
  selectedFolder,
  setSelectedFolder,
  folders,
  showFavorites = false,
  onToggleFavorites,
}: FloorPlanFiltersProps) {
  return (
    <div className="flex flex-col gap-4 md:flex-row md:items-center md:justify-between">
      <div className="flex flex-col gap-4 md:flex-row md:items-center">
        <div className="relative">
          <Search className="absolute left-2 top-2.5 h-4 w-4 text-muted-foreground" />
          <Input
            placeholder="Zoek plattegronden..."
            value={searchQuery}
            onChange={(e) => setSearchQuery(e.target.value)}
            className="pl-8 pr-8 w-full md:w-[200px]"
          />
          {searchQuery && (
            <Button
              variant="ghost"
              size="icon"
              className="absolute right-2 top-2 h-4 w-4 p-0"
              onClick={() => setSearchQuery("")}
            >
              <X className="h-4 w-4" />
            </Button>
          )}
        </div>
        <div className="flex items-center gap-2">
          <FolderIcon className="h-4 w-4 text-muted-foreground" />
          <Select 
            value={selectedFolder} 
            onValueChange={setSelectedFolder}
          >
            <SelectTrigger className="w-full md:w-[200px]">
              <SelectValue placeholder="Filter op map" />
            </SelectTrigger>
            <SelectContent>
              <SelectItem value="all">Alle mappen</SelectItem>
              {folders.map((folder) => (
                <SelectItem key={folder.id} value={folder.id}>
                  {folder.name}
                </SelectItem>
              ))}
            </SelectContent>
          </Select>
          {selectedFolder && (
            <Button
              variant="ghost"
              size="icon"
              className="h-8 w-8"
              onClick={() => setSelectedFolder("")}
            >
              <X className="h-4 w-4" />
            </Button>
          )}
        </div>
        {onToggleFavorites && (
          <div className="flex items-center space-x-2">
            <Switch
              id="favorites"
              checked={showFavorites}
              onCheckedChange={onToggleFavorites}
            />
            <Label htmlFor="favorites">Alleen favorieten</Label>
          </div>
        )}
      </div>
    </div>
  );
}
